// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-navigation-template/src/index.tsx

import baseIcon, { navigationDefaultStyleSheetGetter, defaultNavigationIconGroupProps, defaultNavigationIconShapeSize } from '@bubble-ui/temp-icon-base';
var NavigationIconReturnsPath = 'M10.362 21.234c.27.443.772.677 1.147.796l1.744.512-1.907-7.246a3.765 3.765 0 0 1 .542-3.073L16.116 6H14.78a1.88 1.88 0 0 0-1.242.453l-6.98 6.067c-.593.517-.726 1.302-.327 1.953l4.13 6.761ZM19.892 4l-6.35 9.347c-.298.438-.39.949-.261 1.44l2.807 10.672-5.163-1.516c-1.024-.325-1.802-.899-2.27-1.667l-4.13-6.759c-.911-1.49-.614-3.343.722-4.507l6.977-6.063A3.87 3.87 0 0 1 14.78 4h5.112Zm-1.521 7.044a8.861 8.861 0 0 0-.867-.043v2a6.477 6.477 0 0 1 6.5 6.5 6.445 6.445 0 0 1-2.005 4.695l1.383 1.444a8.423 8.423 0 0 0 2.622-6.14 8.472 8.472 0 0 0-7.633-8.456ZM17.504 15v2c1.378 0 2.5 1.122 2.5 2.5 0 .622-.23 1.218-.647 1.68l1.482 1.341a4.492 4.492 0 0 0 1.165-3.02c0-2.482-2.019-4.5-4.5-4.5Z';
var NavigationIconReturns = baseIcon('NavigationIconReturns', {
  getPath: () => NavigationIconReturnsPath,
  defaultStyleSheetGetter: navigationDefaultStyleSheetGetter,
  groupProps: defaultNavigationIconGroupProps,
  shapeSize: defaultNavigationIconShapeSize
});
export default NavigationIconReturns;
//# sourceMappingURL=index.js.map